export const TIER = {
	PLATINUM: 'PLATINUM',
	PRO: 'PRO',
	PURPLE: 'PURPLE'
};

export default TIER;
